import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

// One entry per toggle click, not one per affected trip-item id -- a return flight or multi-city
// group toggles several ids under the hood (getCartStatusPatchItemIds), but that's one customer
// decision, not several. The id list itself isn't needed here: it has no place in an LLM-context
// sentence, and the item name alone is already unambiguous for every product type.
export function buildCartItemInclusionToggledActivityEntry(
  itemName: string,
  cartExcluded: boolean,
): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'cart_item_inclusion_toggled',
    label: 'Toggled cart inclusion',
    displayText: boundActivityDisplayText(
      `${cartExcluded ? 'Excluded' : 'Included'} "${itemName}" ${cartExcluded ? 'from' : 'in'} the trip total`,
    ),
    sourcePath: 'trip_planner.cart.inclusion_toggle',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
